import { useRef } from 'react'
import { InputGroup, Form } from 'react-bootstrap'
import Select from 'react-select'

export default function UnitSpinButton({options, onChange, value, name, unit, min, max, step, disabled}) {
	const select_ref = useRef()
	const input_ref = useRef()

	const onUnitChange = (selection) => {
		let event = {
			target : {
				value : {
					value : input_ref.current.value,
					unit : selection.value
				}
			}
		}

		onChange(event)
	}

	const onNumberChange = (e) => {
		let event = {
			target : {
				value : {
					value : e.target.value,
					unit : select_ref.current.getValue()[0].value
				}
			}
		}

		onChange(event)
	}


	let u = options.find((i) => i.value === unit)

	if (disabled === undefined)
		disabled = false
	else
		disabled = true

	return (
		<InputGroup className="mb-3">
			<InputGroup.Text>{name}</InputGroup.Text>
			<Form.Control
				ref={input_ref}
				value={value}
				onChange={onNumberChange}
				type="number"
				min={min}
				max={max}
				step={step}
				disabled={disabled}
			/>
			<Select
				ref={select_ref}
				options={options}
				value={u}
				onChange={onUnitChange}
				className="form-control select minified"
				isDisabled={disabled}
			/>
		</InputGroup>
	)
}

